<template>
  <div class="file-upload">
    <input v-show="false" type="file" multiple :accept="accept" ref="uploadRef" @change="handleSelectFile" />
    <div @click="handleUpload" class="file-upload__upload">
      <slot>
        <div>点击上传</div>
      </slot>
    </div>
    <slot name="tip"></slot>
  </div>
</template>
<script setup name="FileUpload">
import { defineProps, ref, getCurrentInstance } from 'vue'
const props = defineProps({
  multiple: { type: Boolean, default: true }, //是否支持多选文件
  accept: { type: String, default: '.' }, //接受上传的文件类型
  limit: { type: Number, default: 1000 }, //允许上传文件的最大数量
  beforeUpload: { type: Function }, //上传文件之前的钩子
  onExceed: { type: Function }, //超出限制时，执行的钩子
  onSuccess: { type: Function }, //文件上传成功是的钩子
  onError: { type: Function }, //文件上传失败时的钩子
  onPreview: { type: Function } //点击文件列表已上传的文件是的钩子
})
const { proxy } = getCurrentInstance()
// 文件选择
const uploadRef = ref(null)
const handleSelectFile = async () => {
  let files = uploadRef.value.files
  if (files.length === 0) return
  // 文件数量超出上传最大限制
  if (files.length > props.limit && props.onExceed && typeof props.onExceed === 'function') {
    return props.onExceed()
  }
  // 上传前限制文件大小
  let flag = true
  if (props.beforeUpload && typeof props.beforeUpload === 'function') {
    flag = props.beforeUpload(files[0])
  }
  if (flag) {
    try {
      const formData = new FormData()
      formData.append('file', files[0])
      let res = await proxy.$http.post('/sys/oss/upload', formData, {
        headers: { 'Content-type': 'multipart/form-data' }
      })
      if (res.code === 0) {
        if (props.onSuccess && typeof props.onSuccess === 'function') {
          props.onSuccess(res)
        }
      } else {
        if (props.onError && typeof props.onError === 'function') {
          props.onError(err)
        }
      }
    } catch (err) {
      if (props.onError && typeof props.onError === 'function') {
        props.onError(err)
      }
    }
  }
}
const handleUpload = () => {
  uploadRef.value.click()
}
</script>
<style lang="less" scoped>
.file-upload {
  &__upload {
    cursor: pointer;
  }
}
</style>
